import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  uploadProductsLabel: {
    defaultMessage: 'Upload Products',
    id: 'l6wPdj',
    description: 'Title for the stepper',
  },
  uploadProductsTitle: {
    defaultMessage: 'Upload Products',
    id: 'XzeVG4',
    description: 'Title in the step',
  },
  uploadProductsDescription: {
    defaultMessage:
      'Make sure all products to be Fulfilled by ShipStation are uploaded in ShipStation by uploading a CSV file or Excel file. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'fWdOsP',
    description: 'Description in the step',
  },
  prepareProducts: {
    defaultMessage: 'Prepare Products',
    id: '34fCPH',
    description: 'Title for the body in the step',
  },
  prepareProductsTitle: {
    defaultMessage: 'Get your products ready to send',
    id: 'G1CbI0',
    description: 'Title in the step',
  },
  prepareProductsDescription: {
    defaultMessage:
      'Follow these steps to finalize your product list, attach barcodes, and prepare packing lists so your inventory arrives ready to be received and stocked.',
    id: 'h+DXsW',
    description: 'Description in the step',
  },
  sendProductsLabel: {
    defaultMessage: 'Send Products',
    id: '79RPVi',
    description: 'Title for the send products stepper',
  },
  sendProductsTitle: {
    defaultMessage: 'Send your products',
    id: 'EvQGQC',
    description: 'Title in the send products step',
  },
  sendProductsDescription: {
    defaultMessage: 'Create an Advance Shipping Notice to send inventory to a ShipStation Fulfillment warehouse.',
    id: 'n5LgD6',
    description: 'Description in the send products step',
  },
  scheduleReviewLabel: {
    defaultMessage: 'Schedule review',
    id: 'piMAPd',
    description: 'Title for the schedule review stepper',
  },
  scheduleReviewTitle: {
    defaultMessage: 'Schedule a Fulfillment Review',
    id: 'Fal/g7',
    description: 'Title in the schedule review step',
  },
  scheduleReviewDescription: {
    defaultMessage:
      'Schedule a 30-minute call with our team to review your fulfillment onboarding selections. We will help review and make sure your ASNs, Order Routing, and product list are all in order prior to submitting them to our Fulfillment center.',
    id: 'qKp85S',
    description: 'Description in the schedule review step',
  },
});
